module.exports = __webpack_public_path__ + "static/img/home_right.c357aab5.png";